import { Link } from 'react-router-dom';
import { useSelectedAccount } from '../App';
import { getPayNowLink } from '../utils/payNow';

import CurrencyPoundIcon from '@mui/icons-material/CurrencyPoundOutlined';
import BuildIcon from '@mui/icons-material/BuildOutlined';
import DescriptionIcon from '@mui/icons-material/DescriptionOutlined';
//import PersonIcon from '@mui/icons-material/PersonOutlined';
import CallIcon from '@mui/icons-material/CallOutlined';
import ReportProblemIcon from '@mui/icons-material/ReportProblemOutlined';

const currency = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'GBP' });

const Home = () => {
    const { selectedAccount } = useSelectedAccount();

    const getBalanceText = () => {
        if (!selectedAccount) return 'Loading balance...';

        const balance = selectedAccount.balance ?? 0;
        const amount = currency.format(Math.abs(balance));

        const prefix = <span className="home__card-text">Current balance </span>;
        const value = <span className="home__card-balance">{amount}</span>;
        const suffix = (
            <span className="home__card-text">
                {balance < 0 ? ' in credit' : ' in debt'}
            </span>
        );

        return (
            <>
                {prefix}
                {value}
                {suffix}
            </>
        );
    };

    const cardData = [
        {
            title: 'MyAccount',
            icon: <CurrencyPoundIcon />,
            description: getBalanceText(),
            buttons: [
                { label: 'View statement', link: '/myaccount', class: 'btn--secondary', external: false },
                { label: 'Pay now', link: getPayNowLink(selectedAccount), external: true, class: '' }
            ]
        },
        {
            title: 'MyRepairs',
            icon: <BuildIcon />,
            description: 'Repairs and communal repairs',
            buttons: [
                { label: 'View Repairs', link: '/myrepairs', class: 'btn--secondary', external: false },
                { label: 'Report repair', link: 'https://www.accentgroup.org/your-home/repairs-and-maintenance/', external: true, class: '' }
            ]
        },
        {
            title: 'MyDocuments',
            icon: <DescriptionIcon />,
            description: 'Access and download copies of some of the recent documents we\'ve sent you',
            buttons: [
                { label: 'View documents', link: '/mydocuments', class: 'btn--secondary', external: false }
            ]
        },
        //{
        //    title: 'MyProfile',
        //    icon: <PersonIcon />,
        //    description: 'Update and manage your contact details',
        //    buttons: [
        //        { label: 'View MyProfile', link: '/myprofile', class: 'btn--secondary', external: false }
        //    ]
        //},
        {
            title: 'Contact Us',
            icon: <CallIcon />,
            description: 'Get in touch',
            buttons: [
                { label: 'Contact us', link: 'https://www.accentgroup.org/contact-us/', external: true, class: '' }
            ]
        },
        {
            title: 'Anti-Social Behaviour',
            icon: <ReportProblemIcon />,
            description: 'Report anti-social behaviour on our website',
            buttons: [
                { label: 'Report', link: 'https://www.accentgroup.org/your-home/anti-social-behaviour/report-difficult-behaviour-in-your-area/', external: true, class: '' }
            ]
        }
    ];

    return (
        <div className="home">
            <div className="home__grid">
                {cardData.map((card, index) => (
                    <div className="home__card" key={index}>
                        <div className="home__card-icon">
                            {card.icon}
                        </div>
                        <h3 className="home__card-title title--h3">{card.title}</h3>
                        <p className="home__card-description">{card.description}</p>
                        <div className="home__card-actions">
                            {card.buttons.map((button, buttonIndex) => {
                                if (!button.link) {
                                    return null;
                                }

                                return button.external ? (
                                    <a key={buttonIndex} href={button.link} target="_blank" rel="noopener noreferrer">
                                        <button className={`btn ${button.class || ''}`}>{button.label}</button>
                                    </a>
                                ) : (
                                    <Link key={buttonIndex} to={button.link}>
                                        <button className={`btn ${button.class || ''}`}>{button.label}</button>
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Home;
